import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Input, message } from 'antd';
import { useAppSelector } from '@/store/hooks';
import { saveEmergencyServiceBidding } from '@/api/emergencyServiceApi';
import { saveCreatearpoolrderBidding,saveFixCarpoolOrder,saveCreateDeliveryOrderBidding,saveFixDeliveryOrder } from '@/api/car';
import styles from './OrderDialog.module.scss';
import { useNavigate } from 'react-router-dom';
import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
export type OrderDialogMode = 'bidding' | 'fixed';


export type OrderDialogOrder = {
   // Delivery Order
  delivery_order_id?: string;
  order_status?: number;
  pickup_time?: string | Dayjs;
  expected_delivery_time?: string | Dayjs;
  item_description?: string;
  quantity?: number;
  package_size?: string;
  package_weight?: string;
  starting_point_state?: string;
  starting_point_city?: string;
  starting_point_address?: string;
  starting_point_latitude?: number;
  starting_point_longitude?: number;
  destination_point_state?: string;
  destination_point_city?: string;
  destination_point_address?: string;
  destination_point_latitude?: number;
  destination_point_longitude?: number;
  final_price?: number;
  budget_price?: number;
  service_requirements?: string;
  notes?: string;
  user_id?: string;
  is_delete?: boolean;
  created_time?: string;
  update_time?: string;
  distance?: number;
  bid_record_count?: number;

  // Carpool Order
  carpool_order_id?: string;
  carpool_order_status?: number;
  departure_date?: string | Dayjs;
  acceptable_advance_delay?: number;
  stopovers?: number;
  seats_needed?: number;
  has_luggage?: boolean;

  partner_user_id?: string;

};

export type OrderDialogProps = {
    open: boolean;
    mode: OrderDialogMode;
    order: OrderDialogOrder;
    defaultBid?: number;
    onConfirm: (payload: { mode: OrderDialogMode; bid?: number }) => void;
    onCancel: () => void;
};

const OrderDialog: React.FC<OrderDialogProps> = ({ open, mode, order, defaultBid, onConfirm, onCancel }) => {
    const navigate = useNavigate();
    const [bid, setBid] = useState<number | undefined>(defaultBid);
    const [loading, setLoading] = useState(false);

    // 获取用户信息和位置信息
    const userInfo = useAppSelector((state) => state.user.userInfo);
    const latitude = useAppSelector((state) => state.user.latitude);
    const longitude = useAppSelector((state) => state.user.longitude);

    //国际化语言切换
    const { t, i18n } = useTranslation();


  // 辅助函数：格式化日期
  const formatDate = (date: string | dayjs.Dayjs | undefined): string => {
    if (!date) return '';
    if (typeof date === 'string') return date;
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

    // 当打开或订单/默认值/模式变化时，重置出价
    useEffect(() => {
        if (open) {
            if (mode === 'bidding') {
                const fallback = Number(order?.budget_price) ?? 0;
                const next = typeof defaultBid === 'number' ? defaultBid : fallback;
                setBid(next);
            } else {
                setBid(undefined);
            }
        }
    }, [open, defaultBid, order, mode]);

    const titleText = useMemo(() => {
        return mode === 'bidding' ? t('OrderDialogCar.BiddingOrder') : t('OrderDialogCar.FixedOrder');
    }, [mode]);


    //竞价和一口价提交
    const handleOk = async () => {
        if (mode === 'bidding') {
            const finalBid = (typeof bid === 'number' && !Number.isNaN(bid)) ? bid : 0;
            // 验证出价不能超过预算上限
            if (finalBid > Number(order.budget_price)) {
                message.error(`The bid cannot exceed the budget limit $${order.budget_price}, please try again`);
                return;
            }
            // 用户信息获取失败
            if (!userInfo?.user_id) {
                message.error('Failed to get user information, please log in again');
                return;
            }
            // 位置信息获取失败
            if (!latitude || !longitude) {
                message.error('Failed to get location information, please check the location permission');
                return;
            }



            setLoading(true);
            try {
                let params:any = {};

                let poolrderBidding:any = null;
       
                if(order.carpool_order_id){
                    // 拼车送人竞价
                    params = {
                        carpool_order_id: order.carpool_order_id,
                        bidding_price: finalBid,
                        bidding_status:0
                    };

                    poolrderBidding = saveCreatearpoolrderBidding;


                } else if(order.delivery_order_id){

                    // 拼车送货竞价
                    params = {
                        delivery_order_id: order.delivery_order_id,
                        bidding_price: finalBid,
                        bidding_status:0
                    };

                    poolrderBidding = saveCreateDeliveryOrderBidding;

                }
                

                const res = await poolrderBidding(params);

                if (res && res.code === 200) {
                    message.success(t('OrderDialogCar.BiddingSuccessfully'));
                    navigate('/carpoolService');
                    onConfirm({ mode, bid: finalBid });
                } else {
                    message.error(res?.message || 'Bid submission failed, please try again');
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        } else {
            // Fixed Price 模式 status=1
            // 用户信息获取失败
            if (!userInfo?.user_id) {
                message.error('Failed to get user information, please log in again');
                return;
            }
            // 位置信息获取失败
            if (!latitude || !longitude) {
                message.error('Failed to get location information, please check the location permission');
                return;
            }

            setLoading(true);
            try {
                let params:any = {};
                let poolrderFix:any = null;

                
                if(order.carpool_order_id){
                     // 拼车送人一口价
                    params = {
                        carpool_order_id: order.carpool_order_id,
                    };

                    poolrderFix = saveFixCarpoolOrder;

                } else if(order.delivery_order_id){
                    // 拼车送货一口价
                    params = {
                        delivery_order_id: order.delivery_order_id,
                    };

                    poolrderFix = saveFixDeliveryOrder;
                }

                const res = await poolrderFix(params);
                if (res && res.code === 200) {
                    message.success('Order confirmed successfully!');
                    navigate('/carpoolService');
                    onConfirm({ mode });
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            footer={null}
            closable={false}
            width={720}
            className={styles.orderDialog}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h3 className={styles.dialogTitle}>{titleText}</h3>
                    <div className={styles.rightDatetime}>
                        {/* <span className={styles.date}>{order.departure_date}</span> */}
                        <span className={styles.time}>{formatDate(t('OrderDialogCar.departuredate'))}</span>
                    </div>
                    <button className={styles.closeBtn} onClick={onCancel} aria-label="Close" />
                </div>

                <div className={styles.summaryRow}>
                    <div className={styles.summaryText}>
                       
                        <div className={styles.distanceRow}>
                            <div className={styles.distance}>
                                <span className={styles.distanceIcon}></span>{`${order.distance?Number(order.distance).toFixed(1):2.5} `} {t('OrderDialogCar.MilesFromYou')}
                            </div>
                        </div>
                        <div className={styles.infoLine}>
                            <span className={styles.label}>{t('OrderDialogCar.Startingpoint')}</span>
                            <span className={styles.value}>
                                {order.starting_point_address + ',' + order.starting_point_city + ',' + order.starting_point_state}
                            </span>
                        </div>
                        <div className={styles.infoLine}>
                            <span className={styles.label}>{t('OrderDialogCar.Destination')}</span>
                            <span className={styles.value}>
                                {order.destination_point_address + ',' + order.destination_point_city + ',' + order.destination_point_state}</span>
                        </div>

                        {/* 拼车送人信息 */}
                        {
                            !!order.carpool_order_id && (
                                <>
                                    <div className={styles.infoLine}>
                                        <span className={styles.label}>{t('OrderDialogCar.Seats')}</span>
                                        <span className={styles.value}>{order.seats_needed} {t('OrderDialogCar.People')}</span>
                                    </div>
                                    <div className={styles.infoLine}>
                                        <span className={styles.label}>{t('OrderDialogCar.Luggage')}</span>
                                        <span className={styles.value}>{order.has_luggage ? t('OrderDialogCar.HasLuggage') : t('OrderDialogCar.NoLuggage')}</span>
                                    </div>
                                    <div className={styles.infoLine}>
                                        <span className={styles.label}>{t('OrderDialogCar.ServiceRequirements')}</span>
                                        <span className={styles.value}>{order.service_requirements}</span>
                                    </div>

                                    <div className={styles.infoLine}>
                                        <span className={styles.label}>{t('OrderDialogCar.Notes')}</span>
                                        <span className={styles.value}>{order.notes}</span>
                                    </div>
                                </>
                            )
                        }
                        {/* 拼车送人信息 */}
                        {/* 拼车送货信息 */}
                        {
                            !!order.delivery_order_id && (
                                <>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Pickup Time:</span>
                                    <span className={styles.value}>{formatDate(order.pickup_time)}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Expected Delivery Time:</span>
                                    <span className={styles.value}>{formatDate(order.expected_delivery_time)}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Item Description:</span>
                                    <span className={styles.value}>{order.item_description}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Quantity:</span>
                                    <span className={styles.value}>{order.quantity}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Package Size:</span>
                                    <span className={styles.value}>{order.package_size}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Package Weight:</span>
                                    <span className={styles.value}>{order.package_weight}</span>
                                </div>
                                <div className={styles.infoLine}>
                                    <span className={styles.label}>Notes:</span>
                                    <span className={styles.value}>{order.notes}</span>
                                </div>
                                </>
                                  
                            )
                        }
                    </div>
                </div>

                <div className={styles.separator} />

                <div className={styles.priceRow}>
                    <span className={styles.priceLabel}>{mode === 'bidding' ? t('OrderDialogCar.Budget') : t('OrderDialogCar.Price')} </span>
                    <span className={styles.currency}>$</span>
                    <span className={styles.price}>{mode == 'bidding' ? order.budget_price : order.final_price}</span>
                </div>

                {mode === 'bidding' && (
                    <div className={styles.bidRow}>
                        <label className={styles.bidLabel} htmlFor="bid-input">Bidding($):</label>
                        <Input
                            id="bid-input"
                            className={styles.bidInput}
                            value={bid as any}
                            inputMode="decimal"
                            onChange={(e) => {
                                const numeric = Number(e.target.value.replace(/[^0-9.]/g, ''));
                                if (Number.isNaN(numeric)) {
                                    setBid(undefined);
                                    return;
                                }

                                // 验证不能超过预算上限
                                if (numeric > (mode == 'bidding' ? Number(order.budget_price) : Number(order.final_price))) {
                                    setBid(mode == 'bidding' ? Number(order.budget_price) : Number(order.final_price));
                                    message.warning(`The bid cannot exceed the budget limit of $${mode == 'bidding' ? Number(order.budget_price) : Number(order.final_price)}`);
                                    return;
                                }

                                setBid(numeric);
                            }}
                            onBlur={() => { /* 无下限，有上限（预算） */ }}
                            placeholder={mode === 'bidding' ? `Enter your bid (≤ $${mode == 'bidding' ? Number(order.budget_price) : Number(order.final_price)})` : 'Enter your bid'}
                        />
                    </div>
                )}

                <div className={styles.footer}>
                    <button className={styles.cancelBtn} onClick={onCancel} disabled={loading}>{t('common.Cancel')}</button>
                    <button className={styles.confirmBtn} onClick={handleOk} disabled={loading}>
                        {loading ? t('OrderDialogCar.Submitting') : t('common.Confirm')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OrderDialog;

